<div class="layout-container" [class.sidebar-collapsed]="isCollapsed" [class.sidebar-mobile-open]="isMobileOpen">

  <!-- Sidebar -->
  <aside class="menu-area">
    <!-- home-layout.component.html -->
    <app-side-bar [collapsed]="isCollapsed" [openGroupKey]="openGroupKey" (expandRequest)="onExpandRequest($event)">
    </app-side-bar>
  </aside>

  <!-- Main -->
  <main class="content-area">
    <div class="topbar-wrap">
      <app-top-bar (menuToggle)="onToggleSidebar()"></app-top-bar>
      <hr class="m-0 py-0" />
    </div>

    <div class="content-scroll">
      <router-outlet></router-outlet>
    </div>

    <footer class="footer">
      <span>© {{ currentYear }} CIXOR</span>
      <span class="spacer"></span>
      <!-- <a class="hover-anchor" (click)="notDeveloped()">Privacy</a><span class="dot">•</span><a class="hover-anchor" (click)="notDeveloped()">Terms</a> -->
    </footer>
  </main>

  <!-- Backdrop for mobile -->
  <div class="backdrop" *ngIf="isMobileOpen" (click)="onBackdropClick()"></div>
</div>